import { render, staticRenderFns } from "./pax_form.vue?vue&type=template&id=4e7f1231&"
import script from "./pax_form.vue?vue&type=script&lang=js&"
export * from "./pax_form.vue?vue&type=script&lang=js&"
import style0 from "./pax_form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports